import React, { useState } from "react";
import { Typography, Table, Tag, Tooltip, Button } from "antd";
import Patient from "../../../tables/Patient";
import Date from "../../tableItems/Date";
import PatientBranch from "../../../tables/PatientBranch";
import { FormattedMessage } from "react-intl";
import { DeleteOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import moment from "moment";

const { Text } = Typography;
const SchedulingTable = (props) => {
  const {
    events,
    loading,
    onDelete,
    onReplaceEmployee,
    changeSelectedEvents,
    selectedEvents,
    onShowTransferScheduling,
    sameChosenEventsBranches,
    abscenceActions,
  } = props;
  const intl = useIntl();

  const onDeleteEvent = (record) => {
    onDelete(record);
  };
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.patient",
      }),
      dataIndex: "order",
      render(text, record) {
        return <Patient record={record.order.patient} />;
      },
      sorter: (a, b) =>
        a.order.patient.surename.localeCompare(b.order.patient.surename),
      sortDirections: ["descend", "ascend"],
      ellipsis: true,
      width: "200px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.branch",
      }),
      dataIndex: "order",
      width: "110px",
      render(text, record) {
        return (
          <PatientBranch record={{ branch_id: record.order.patient.branch }} />
        );
      },
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.date",
      }),
      dataIndex: "date",
      render(text, record) {
        return <Date text={text} format={"L"} />;
      },
      sorter: (a, b) => a["date"].localeCompare(b["date"]),
      sortDirections: ["descend", "ascend"],
      width: "110px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.dayInWeek",
      }),
      responsive: ["lg"],
      dataIndex: "date",
      render(text, record) {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
      width: "80px",
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.hours",
      }),
      responsive: ["md"],
      render(text, record) {
        return record ? (
          <Text>{`${moment(record.date).format("HH:mm")} : ${moment(record.date)
            .add(record.duration_minutes, "minutes")
            .format("HH:mm")}`}</Text>
        ) : null;
      },
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.client",
      }),
      dataIndex: "order",
      responsive: ["lg"],
      render(text, record) {
        return (
          <Text ellipsis={true}>
            {text["client"] ? text["client"]["name"] : ""}
          </Text>
        );
      },
      sorter: (a, b) => a.order.client.name.localeCompare(b.order.client.name),
      sortDirections: ["descend", "ascend"],
      width: "150px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.status",
      }),
      responsive: ["md"],
      dataIndex: "approved",
      render(text, record) {
        return text ? (
          <Tag color="success">
            {intl.formatMessage({
              id: "app.scheduling.table.verified",
            })}
          </Tag>
        ) : record.ghost ? (
          <Tag color="error">
            {intl.formatMessage({
              id: "app.scheduling.table.deleted",
            })}
          </Tag>
        ) : null;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.actions",
      }),
      responsive: ["md"],
      width: "100px",
      render(text, record) {
        return (
          <div style={{ display: "flex" }}>
            {!record.approved && !record.ghost && (
              <Tooltip
                title={intl.formatMessage({
                  id: "app.absences.deleteScheduling",
                })}
              >
                <Button
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => onDeleteEvent(record)}
                  style={{ color: "red" }}
                />
              </Tooltip>
            )}
            {!record.approved && (
              <Tooltip
                title={intl.formatMessage({
                  id: "app.absences.replaceScedulingEmployee",
                })}
              >
                <Button
                  type="text"
                  icon={<UserSwitchOutlined />}
                  onClick={() => onReplaceEmployee(record)}
                />
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    changeSelectedEvents(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys: selectedEvents,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.approved,
    }),
  };
  return (
    <div style={{}}>
      <Table
        bordered
        pagination={false}
        columns={columns}
        dataSource={events}
        rowKey={(record) => record.id}
        scroll={{ y: window.innerHeight - 246 }}
        loading={loading}
        rowSelection={events && events.length > 0 && rowSelection}
      />
      {events && events.length > 0 ? (
        <div
          style={{
            paddingTop: "10px",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Button
            onClick={onShowTransferScheduling}
            disabled={selectedEvents.length === 0 || !sameChosenEventsBranches}
          >
            <FormattedMessage id={`app.actions.transfer_employee_scheduling`} />
          </Button>
          {abscenceActions}
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default SchedulingTable;
